export default __webpack_public_path__ + "media/images/admin/search-6c426ffa0449b2dfe06f2ac530abbcb0.svg";